var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dl",
    {
      staticClass: "appeal-point-block",
      style:
        "background: url(" +
        _vm.userCommonImageUrlForSp +
        "/bg_stripe_gray.png) repeat top left;",
    },
    [
      _vm.freeTopic.title
        ? _c("dt", [_vm._v("\n    " + _vm._s(_vm.freeTopic.title) + "\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _c("dd", [
        _vm.freeTopic.photo
          ? _c("img", {
              staticClass: "offer-img-sub image-height-auto",
              attrs: { src: _vm.getPhotoUrl(_vm.freeTopic.photo) },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("p", {
          staticClass: "pega-pre-wrap",
          domProps: { textContent: _vm._s(_vm.freeTopic.body) },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }